import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StorageService } from 'src/app/services/storage.service';
import { ApsAssignedFacade } from 'src/app/ngrx/aps_assinged/aps_assinged.facade';
import { UpdateToServerModalComponent } from '../update-to-server-modal/update-to-server-modal.component';
import { ApiService } from 'src/app/services/api.service';
import { FormDataFacade } from 'src/app/ngrx/form-data/form-data.facade';
import { ApsAssignedList } from 'src/app/models/aps-assigned-list';
import { Network } from '@ngx-pwa/offline';
import { Router } from '@angular/router';

@Component({
  selector: 'app-data-expiry-modal',
  templateUrl: './data-expiry-modal.component.html',
  styleUrls: ['./data-expiry-modal.component.scss']
})
export class DataExpiryModalComponent implements OnInit {
  expiredIDs = [];
  reportList: Array<ApsAssignedList> = [];
  online$ = this.network.online;
  constructor(
    public bsModalRefDataExpiry: BsModalRef,
    public bsModalRef: BsModalRef,
    private storage: StorageService,
    private apsAssignedFacade: ApsAssignedFacade,
    private fdFacade: FormDataFacade,
    private modalService: BsModalService,
    private api: ApiService,
    protected network: Network,
    private router: Router,
  ) { }

  ngOnInit() {
    // console.log(this.expiredIDs);
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    this.apsAssignedFacade.getApsAssignedCheckOutList(assignedAgentId, this.expiredIDs).subscribe(
      doc => {
        this.reportList = doc;
      }
    );
    if (this.expiredIDs.length === 0) {
      this.bsModalRefDataExpiry.hide();
    }
  }

  closeModal() {
    const selectedId = this.storage.getLocalValue('selectedID');
    let needRedirect = false;
    this.reportList.map(
      (report) => {
        this.removeData(report.aps_report_load_id);
        if (selectedId !== null && selectedId !== undefined) {
          if (report.aps_report_load_id.toString() === selectedId.toString()) {
            needRedirect = true;
          }
        }
      }
    );

    if (needRedirect) {
      this.router.navigate(['report-list']);
    }
    this.bsModalRefDataExpiry.hide();
  }

  uploadDataToServer(id) {
    const initialState = {
      selectedIDs: [id],
      removeDataFN: () => this.removeData(id)
    };
    this.modalService.config.ignoreBackdropClick = true;
    this.modalService.config.class = 'modal-lg';
    this.bsModalRef = this.modalService.show(UpdateToServerModalComponent, {initialState});
  }

  removeData(id) {
    this.bsModalRefDataExpiry.hide();
    if (this.online$) {
      this.api.removeFromCheckoutList(id).subscribe(
        data => console.log('removed', data.aps_report_load_id)
      );
    }
    this.apsAssignedFacade.deleteApsAssignedCheckOutItem([id]);
    this.fdFacade.deleteDataToDB([id]);
    this.reportList = this.reportList.filter(data => data.aps_report_load_id !== id);
  }

}
